import { ClientEffects } from '../effects/client.effects'
import { EmployeeEffects } from '../effects/employee.effects'
import { VehicleEffects } from './vehicle.effects'

export const mainEffects = [
    ClientEffects,
    EmployeeEffects,
    VehicleEffects
]